import React, { useState, useEffect } from "react";
import AdheseInit from "./components/AdheseInit";
import defaultLogo from "./asset/img/UCM-Logo.png";

const DummyProduct = ({ i }) => (
  <div className="bg-white p-4 border rounded shadow">
    <div className="h-40 bg-gray-200 mb-2" />
    <h3 className="text-lg font-semibold">Product Name {i + 1}</h3>
    <p>$99.99</p>
  </div>
);

export default function App() {
  const [headerImage, setHeaderImage] = useState(defaultLogo);
  const [headerCompany, setHeaderCompany] = useState(null);

  // Fetch header data (logo and company)
  useEffect(() => {
    const fetchHeaderData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const slotId = urlParams.get("adhesePreviewSlotId");

      try {
        const response = await fetch(
          `https://ucm-image-db.lawrencesalazardev.workers.dev/images?slot_id=${slotId}`,
        );
        const data = await response.json();

        if (data && data.image_path) {
          setHeaderImage(data.image_path);
          setHeaderCompany(data.company);
        } else {
          setHeaderImage(
            "https://uncommon-media.com/wp-content/uploads/2024/09/cropped-Uncommon-Media-Black-SMALL.jpg",
          );
          setHeaderCompany(null);
        }
      } catch (error) {
        setHeaderImage(
          "https://uncommon-media.com/wp-content/uploads/2024/09/cropped-Uncommon-Media-Black-SMALL.jpg",
        );
        setHeaderCompany(null);
      }
    };

    fetchHeaderData();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Inject Adhese logic */}
      <AdheseInit />

      {/* Header with Logo and 728x90 Ad */}
      <div
        className="w-full py-[40px] relative"
        style={{ backgroundColor: "#959595" }}
      >
        <div className="max-w-screen-xl mx-auto px-4 flex items-center justify-between">
          {/* Logo and Company Name */}
          <div className="flex items-center">
            <img
              src={headerImage}
              alt="Company Logo"
              className="h-20 max-w-[220px] w-auto object-contain rounded-md mr-4"
            />
            {headerCompany && (
              <h1 className="text-2xl font-bold text-white">{headerCompany}</h1>
            )}
          </div>

          {/* Absolutely centered 728x90 ad */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <div
              id="728x90"
              className="ad_tag w-[728px] h-[90px] bg-white border flex items-center justify-center text-sm text-gray-500"
            >
              Loading 728x90 Leaderboard...
            </div>
          </div>
        </div>
      </div>

      {/* Billboard 970x250 */}
      <div className="flex justify-center my-4">
        <div
          id="970x250"
          className="ad_tag w-[970px] h-[250px] border bg-white flex items-center justify-center text-sm text-gray-500"
        >
          Loading 970x250 Billboard...
        </div>
      </div>

      {/* Main Content with Left Ad */}
      <div className="flex max-w-screen-xl mx-auto px-4 py-6">
        {/* Left Ad */}
        <div className="w-[300px] mr-4 hidden lg:block">
          <div
            id="300x600"
            className="ad_tag h-[600px] border bg-white flex items-center justify-center text-sm text-gray-500"
          >
            Loading 300x600 Ad...
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1">
          <h2 className="text-xl font-semibold mb-4">Featured Products</h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <DummyProduct key={i} i={i} />
            ))}
          </div>

          {/* Medium Rectangle Ad between content */}
          <div className="flex justify-center my-8">
            <div
              id="300x250"
              className="ad_tag w-[300px] h-[250px] border bg-white flex items-center justify-center text-sm text-gray-500"
            >
              Loading Medium Rectangle...
            </div>
          </div>

          {/* More Products */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <DummyProduct key={i + 8} i={i + 8} />
            ))}
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="w-[160px] ml-4 hidden lg:block">
          <div
            id="160x600"
            className="ad_tag h-[600px] border bg-white flex items-center justify-center text-sm text-gray-500"
          >
            Loading Skyscraper...
          </div>
        </div>
      </div>
    </div>
  );
}
